// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3ZJbJ","inputWrap":"CustomTip_inputWrap__3t7zU"};